export default Object.freeze({
  FEEDBACK_CACHE_KEY_PREFIX: 'ai_chat_feedback_',
})
